// extracted by mini-css-extract-plugin
module.exports = {"wrap":"preloader_wrap__3rNZF","wrapSmall":"preloader_wrapSmall__xrpr4"};